import settings from '@/settings'

import type { App } from 'vue'
import type { Router } from 'vue-router'

import * as Sentry from '@sentry/vue'

import { isStaleChunkReloadPending } from './staleChunkReload'

interface SentryPluginOptions {
  router: Router
}

export default function install(app: App, { router }: SentryPluginOptions) {
  if (!settings.SENTRY_DSN) {
    console.warn('SENTRY_DSN not found in settings, error monitoring disabled')
    return
  }

  Sentry.init({
    app,
    dsn: settings.SENTRY_DSN,
    environment: settings.ENVIRONMENT || 'unknown',
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
    tracesSampleRate: settings.ENVIRONMENT === 'prod' ? 0.2 : 1,
    replaysSessionSampleRate: settings.ENVIRONMENT === 'prod' ? 0.1 : 1,
    replaysOnErrorSampleRate: 1,
    initialScope: { tags: { region: settings.REGION } },
    beforeSend: (event) => (isStaleChunkReloadPending() ? null : event),
  })
}
